unit NarociloInfo;

interface

uses
  System.SysUtils, System.Classes, Vcl.Forms, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection, WEBLib.ExtCtrls, WEBLib.DB, WEBLib.DBCtrls, WEBLib.Grids, MobileForm, Vcl.Grids,
  WEBLib.CDS, System.DateUtils, Vcl.Mask, WEBLib.Mask;

type
  TfrmNarociloInfo = class(TMobileForm)
    btnOk: TButton;
    wdsPodrobno: TXDataWebDataSet;
    dsPodrobno: TDataSource;
    dsEdit: TDataSource;
    wdsEdit: TXDataWebDataSet;
    edtDatum: TDBDateTimePicker;
    edtLokacija: TDBEdit;
    edtOpombe: TDBMemo;
    edtFrakcija: TDBEdit;
    procedure btnOkClick(Sender: TObject);
    procedure FormShow(Sender: TObject);
    procedure btnCancelClick(Sender: TObject);
  protected
    procedure ApplyTheme(Dark: boolean); reintroduce;
  private
    FSamoZaBranje: boolean;
    FNalogId: integer;
    { Private declarations }
  public
    { Public declarations }
    property NalogId: integer read FNalogId write FNalogId;
    property SamoZaBranje: boolean read FSamoZaBranje write FSamoZaBranje;
  protected procedure LoadDFMValues; override; end;

var
  frmNarociloInfo: TfrmNarociloInfo;

implementation

{$R *.dfm}

uses Main, Client.Core, Client.Settings, Auth.Service;

procedure TfrmNarociloInfo.btnCancelClick(Sender: TObject);
begin
  frmMain.ShowNarocila;
end;

procedure TfrmNarociloInfo.btnOkClick(Sender: TObject);
begin
  frmMain.ShowNarocila;
end;

procedure TfrmNarociloInfo.ApplyTheme(Dark: boolean);
begin
  inherited;
end;

procedure TfrmNarociloInfo.FormShow(Sender: TObject);
begin
  inherited;

  Console.Log('Odpiranje naloga '+FNalogId.ToString+'...');

  // Nalog
  wdsEdit.Close;
  wdsEdit.QueryString := '$filter=id eq '+FNalogId.ToString+'';
  wdsEdit.Load;

  // Podrobno
  wdsPodrobno.Close;
  wdsPodrobno.QueryString := '$filter=nalog/id eq '+FNalogId.ToString+'&$expand=frakcija';
  wdsPodrobno.Load;


  ApplyTheme(AppSettings.DarkMode);
end;


procedure TfrmNarociloInfo.LoadDFMValues;
begin
  inherited LoadDFMValues;

  btnOk := TButton.Create('btnOk');
  edtDatum := TDBDateTimePicker.Create('edtDatum');
  edtLokacija := TDBEdit.Create('edtLokacija');
  edtOpombe := TDBMemo.Create('edtOpombe');
  edtFrakcija := TDBEdit.Create('edtFrakcija');
  wdsPodrobno := TXDataWebDataSet.Create(Self);
  dsPodrobno := TDataSource.Create(Self);
  dsEdit := TDataSource.Create(Self);
  wdsEdit := TXDataWebDataSet.Create(Self);

  btnOk.BeforeLoadDFMValues;
  edtDatum.BeforeLoadDFMValues;
  edtLokacija.BeforeLoadDFMValues;
  edtOpombe.BeforeLoadDFMValues;
  edtFrakcija.BeforeLoadDFMValues;
  wdsPodrobno.BeforeLoadDFMValues;
  dsPodrobno.BeforeLoadDFMValues;
  dsEdit.BeforeLoadDFMValues;
  wdsEdit.BeforeLoadDFMValues;
  try
    Name := 'frmNarociloInfo';
    Left := 0;
    Top := 0;
    Align := alClient;
    Color := clBtnFace;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -27;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    SetEvent(Self, 'OnShow', 'FormShow');
    btnOk.SetParentComponent(Self);
    btnOk.Name := 'btnOk';
    btnOk.Left := 208;
    btnOk.Top := 328;
    btnOk.Width := 225;
    btnOk.Height := 49;
    btnOk.ChildOrder := 3;
    btnOk.ElementFont := efCSS;
    btnOk.ElementPosition := epIgnore;
    btnOk.HeightStyle := ssAuto;
    btnOk.HeightPercent := 100.000000000000000000;
    btnOk.WidthStyle := ssAuto;
    btnOk.WidthPercent := 100.000000000000000000;
    SetEvent(btnOk, Self, 'OnClick', 'btnOkClick');
    edtDatum.SetParentComponent(Self);
    edtDatum.Name := 'edtDatum';
    edtDatum.Left := 210;
    edtDatum.Top := 30;
    edtDatum.Width := 223;
    edtDatum.Height := 48;
    edtDatum.HeightStyle := ssAuto;
    edtDatum.WidthStyle := ssAuto;
    edtDatum.BorderStyle := bsSingle;
    edtDatum.ChildOrder := 1;
    edtDatum.Color := clWhite;
    edtDatum.Date := 45672.402731620370000000;
    edtDatum.ElementFont := efCSS;
    edtDatum.ElementPosition := epIgnore;
    edtDatum.ReadOnly := True;
    edtDatum.Role := '';
    edtDatum.Text := '';
    edtDatum.DataField := 'DatumDostave';
    edtDatum.DataSource := dsEdit;
    edtLokacija.SetParentComponent(Self);
    edtLokacija.Name := 'edtLokacija';
    edtLokacija.Left := 210;
    edtLokacija.Top := 168;
    edtLokacija.Width := 335;
    edtLokacija.Height := 45;
    edtLokacija.ElementFont := efCSS;
    edtLokacija.ElementPosition := epIgnore;
    edtLokacija.HeightStyle := ssAuto;
    edtLokacija.HeightPercent := 100.000000000000000000;
    edtLokacija.ReadOnly := True;
    edtLokacija.WidthStyle := ssAuto;
    edtLokacija.WidthPercent := 100.000000000000000000;
    edtLokacija.DataField := 'LokacijaOpis';
    edtLokacija.DataSource := dsEdit;
    edtOpombe.SetParentComponent(Self);
    edtOpombe.Name := 'edtOpombe';
    edtOpombe.Left := 210;
    edtOpombe.Top := 84;
    edtOpombe.Width := 335;
    edtOpombe.Height := 53;
    edtOpombe.ElementFont := efCSS;
    edtOpombe.ElementPosition := epIgnore;
    edtOpombe.HeightStyle := ssAuto;
    edtOpombe.HeightPercent := 100.000000000000000000;
    edtOpombe.ReadOnly := True;
    edtOpombe.SelLength := 0;
    edtOpombe.SelStart := 0;
    edtOpombe.WidthStyle := ssAuto;
    edtOpombe.WidthPercent := 100.000000000000000000;
    edtOpombe.DataField := 'Opombe';
    edtOpombe.DataSource := dsEdit;
    edtFrakcija.SetParentComponent(Self);
    edtFrakcija.Name := 'edtFrakcija';
    edtFrakcija.Left := 210;
    edtFrakcija.Top := 219;
    edtFrakcija.Width := 335;
    edtFrakcija.Height := 45;
    edtFrakcija.ElementFont := efCSS;
    edtFrakcija.ElementPosition := epIgnore;
    edtFrakcija.HeightStyle := ssAuto;
    edtFrakcija.HeightPercent := 100.000000000000000000;
    edtFrakcija.ReadOnly := True;
    edtFrakcija.WidthStyle := ssAuto;
    edtFrakcija.WidthPercent := 100.000000000000000000;
    edtFrakcija.DataField := 'Frakcija.Opis';
    edtFrakcija.DataSource := dsPodrobno;
    wdsPodrobno.SetParentComponent(Self);
    wdsPodrobno.Name := 'wdsPodrobno';
    wdsPodrobno.EntitySetName := 'PrevozniNalogPodrobno';
    wdsPodrobno.Connection := modMain.connServer;
    wdsPodrobno.SubpropsDepth := 1;
    wdsPodrobno.Left := 88;
    wdsPodrobno.Top := 24;
    dsPodrobno.SetParentComponent(Self);
    dsPodrobno.Name := 'dsPodrobno';
    dsPodrobno.DataSet := wdsPodrobno;
    dsPodrobno.Left := 88;
    dsPodrobno.Top := 80;
    dsEdit.SetParentComponent(Self);
    dsEdit.Name := 'dsEdit';
    dsEdit.DataSet := wdsEdit;
    dsEdit.Left := 16;
    dsEdit.Top := 80;
    wdsEdit.SetParentComponent(Self);
    wdsEdit.Name := 'wdsEdit';
    wdsEdit.EntitySetName := 'PrevozniNalog';
    wdsEdit.Connection := modMain.connServer;
    wdsEdit.SubpropsDepth := 1;
    wdsEdit.Left := 16;
    wdsEdit.Top := 24;
  finally
    btnOk.AfterLoadDFMValues;
    edtDatum.AfterLoadDFMValues;
    edtLokacija.AfterLoadDFMValues;
    edtOpombe.AfterLoadDFMValues;
    edtFrakcija.AfterLoadDFMValues;
    wdsPodrobno.AfterLoadDFMValues;
    dsPodrobno.AfterLoadDFMValues;
    dsEdit.AfterLoadDFMValues;
    wdsEdit.AfterLoadDFMValues;
  end;
end;

end.
